import _Balloon from "@alifd/next/es/balloon";
import _Icon from "@alifd/next/es/icon";
import React from 'react';
export default function titleMessageRender(title, message, prefix) {
  if (!message) {
    return title;
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: prefix + "column-title"
    }, title, /*#__PURE__*/React.createElement(_Balloon.Tooltip, {
      trigger: /*#__PURE__*/React.createElement(_Icon, {
        type: "prompt-filling",
        className: prefix + "column-tooltip",
        size: "small"
      }),
      align: "t"
    }, message));
  }
}